import { Form as RacForm } from 'react-aria-components';
import styled from 'styled-components';
import { FormOrientation } from './Form.types';

export const Form = styled(RacForm)<{
  $orientation: FormOrientation;
  $withLabels: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-base);
  width: 100%;

  &:is(.product__purchase-options &) {
    flex-direction: row;
    gap: var(--spacing-small);
  }

  @media (width >= 48rem) {
    ${props =>
      props.$orientation === FormOrientation.Inline
        ? `
      flex-direction: row;

      & button {
        margin-block-start: 24px;

        &:is(.product__purchase-options &) {
          margin-block-start: 0;
        }
      }
    `
        : `
      flex-direction: column;
    `}
    align-items: flex-start;
  }
`;
